module.exports = __webpack_public_path__ + "cabff8eb41e6852ae81aa83647180764.svg";